import { setUser } from "../utils/comman/Common";
import { toast } from "react-toastify";
import moment from "moment";

import { SHA256 } from "crypto-js";
import axiosinstances from "../Helper/useAxios";

async function userLogin(creds) {
  const salt = process.env.REACT_APP_SALT;
  function generateHash(input, salt) {
    return SHA256(input + salt).toString();
  }
  const txtToHash = creds.values?.password + creds?.unique_id;

  const hashedPassword = generateHash(txtToHash, salt).toUpperCase();

  const request = {
    requestId: creds?.unique_id,
    timestamp: new Date(),
    username: creds?.values?.id,
    password: hashedPassword,
  };
  const userIp = creds.userIp;
  const [axiosInstance] = axiosinstances(userIp);
  const date = moment().toDate();
  const loginUrl = process.env.REACT_APP_LOGIN;
  return axiosInstance
    .post(`${loginUrl}`, { ...request })
    .then((response) => {
      console.log("response", response);
      if (
        response?.status == 200 &&
        response?.data.token !== undefined &&
        response?.data.token !== null &&
        response?.data.token !== ""
      ) {
        const result = response?.data.token;
        console.log("result", result);
        if (result) {
          setUser(
            result,
            response?.data?.name,
            creds?.values?.id,
            response?.data?.sessionId,
            response.data?.requestId,
            response.data?.merchant?.id
          );
        }
        console.log();
        return response;
      }
      if (
        response?.status == 200 &&
        response?.data?.merchant == null &&
        response?.data?.name == null &&
        response?.data?.responseCode !== undefined
      ) {
        toast.error(response.data?.responseCode);
        return false;
      }

      toast.error(response.data.response.displayMsg);
      return false;
    })
    .catch((err) => {
      //console.log(err);
    });
}
export default userLogin;
